import FJLocalStore from '../../../../store/FJLocalStore';
import FJLoading from '../../../../common/components/FJLoading/FJLoading';
import styles from './FJFake3dInput.module.less';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJConstant from '../../../../constants/FJConstant';
import UploadBorder265Icon from '../../../../assets/svg/upload-border-265.svg?react';
import UploadBorder265HoverIcon from '../../../../assets/svg/upload-border-265-hover.svg?react';
import UploadBorder80Icon from '../../../../assets/svg/upload-border-80.svg?react';
import UploadBorder80HoverIcon from '../../../../assets/svg/upload-border-80-hover.svg?react';
import FJUtil from '../../../../util/FJUtil';
import FJEvent from '../../../../store/FJEvent.js';
import FJImageInputTwo from '../../../../common/components/FJImageInput/FJImageInputTwo.jsx';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../../config/dataConfig/FJGenerateData.js';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput.jsx';
import { useMemo } from 'react';

const FJFake3dInput = props => {
    const {
        uploadImg,
        uploadStatus = FJConstant.DEFAULT,
        isSmallComponent = false,
        originImage = {},
        previewImage = {},
        cancelDepthMapTask,
        isDraggingFile,
        setIsDraggingFile,
        openMediaLibrary,
    } = props;

    const imageInfo = useMemo(() => {
        if (!originImage) return undefined;
        return {
            ...originImage,
            name: originImage.name || FJLocalStore._('image'),
        };
    }, [originImage]);

    const _onUploadImg = async file => {
        const spaceType = await FJUtil.checkUserSpace();
        if (spaceType > 0) {
            FJEvent.dispatch(FJConstant.USER_SPACE_CHANGE, spaceType);
            return;
        }
        uploadImg(file);
    };

    const _onDragOver = e => {
        setIsDraggingFile(true);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragLeave = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
    };

    const _onDragDrop = e => {
        setIsDraggingFile(false);
        e.stopPropagation();
        e.preventDefault();
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            _onUploadImg(file);
        }
    };
    const _onCancel = e => {
        e.preventDefault();
        e.stopPropagation();
        cancelDepthMapTask && cancelDepthMapTask();
    };
    const renderEmptyUpload = () => {
        return (
            <FJImageInputTwo
                uploadImg={_onUploadImg}
                acceptFile={UPLOAD_FILE_TYPE_NO_GIF}
                openMediaLibrary={openMediaLibrary}
                text={FJLocalStore._('upload-an-image-to-generate-3d-animation')}
            />
        );
    };
    const renderGenerating = () => {
        return (
            <>
                <div className={styles.preview_box}>
                    <img src={previewImage.src} loading='lazy' className={styles.preview_img} />
                    <div className={styles.loading}>
                        <FJLoading />
                    </div>
                </div>
                <div className={styles.generating_text}>{FJLocalStore._('processing')}</div>
                <div className={styles.cancel} onClick={_onCancel}>
                    {FJLocalStore._('cancel')}
                </div>
                {renderBorder()}
            </>
        );
    };

    const renderBorder = () => {
        return (
            <div className={styles.upload_border_box}>
                {isSmallComponent ? (
                    <>
                        <UploadBorder80Icon className={styles.upload_border} />
                        <UploadBorder80HoverIcon className={styles.upload_border_hover} />
                    </>
                ) : (
                    <>
                        <UploadBorder265Icon className={styles.upload_border} />
                        <UploadBorder265HoverIcon className={styles.upload_border_hover} />
                    </>
                )}
            </div>
        );
    };
    const renderSuccess = () => {
        return (
            <FJImageInput
                uploadImageInfo={imageInfo}
                uploadImg={_onUploadImg}
                isDraggingFile={isDraggingFile}
                setIsDraggingFile={setIsDraggingFile}
                style={{
                    height: 80,
                }}
                openMediaLibrary={openMediaLibrary}
            />
        );
    };
    const renderMain = () => {
        switch (uploadStatus) {
            case FJConstant.DEFAULT:
                return renderEmptyUpload();
            case FJConstant.SUCCESS:
                return renderSuccess();
            default:
                return renderGenerating();
        }
    };

    return (
        <div
            className={classNames(
                styles.box,
                isDraggingFile && styles.dragging,
                isSmallComponent && styles.small,
                uploadStatus === FJConstant.SUCCESS && styles.success,
            )}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
        >
            {renderMain()}
        </div>
    );
};

FJFake3dInput.propTypes = {
    uploadImg: PropTypes.func,
    isLoading: PropTypes.bool,
    isUploading: PropTypes.bool,
    uploadStatus: PropTypes.string,
    isSmallComponent: PropTypes.bool,
    originImage: PropTypes.object,
    cancelDepthMapTask: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    previewImage: PropTypes.object,
    openMediaLibrary: PropTypes.func,
};

export default FJFake3dInput;
